import {DependenciesPickerRelationshipsServerQuery} from '@github-ui/server-persisted-queries'
import type {DependenciesPickerRelationshipsServerQueryQuery} from '@github-ui/server-persisted-queries/types/DependenciesPickerRelationshipsServerQuery'
import {reactFetchJSON} from '@github-ui/verified-fetch'

export type DependenciesPickerRelationshipsIssue = Extract<
  DependenciesPickerRelationshipsServerQueryQuery['node'],
  {readonly __typename: 'Issue'}
>

export function dependenciesPickerRelationshipsQueryKey(repositoryNameWithOwner: string, issueNumber: number) {
  return ['issue-viewer', 'dependencies-picker-relationships', {repositoryNameWithOwner, issueNumber}] as const
}

export async function fetchDependenciesPickerRelationships(
  repositoryNameWithOwner: string,
  issueNumber: number,
  signal?: AbortSignal,
): Promise<DependenciesPickerRelationshipsIssue | null> {
  const query = new URLSearchParams({queryId: DependenciesPickerRelationshipsServerQuery})
  const response = await reactFetchJSON(
    `/${repositoryNameWithOwner}/issues/${issueNumber}/dependencies_picker_relationships.json?${query.toString()}`,
    {signal},
  )

  if (!response.ok) throw new Error(`Dependencies picker relationships fetch failed (${response.status})`)

  const json = (await response.json()) as {
    data?: DependenciesPickerRelationshipsServerQueryQuery
    errors?: unknown[]
  }
  if (!json.data) throw new Error('Dependencies picker relationships query returned no data')

  return json.data.node?.__typename === 'Issue' ? json.data.node : null
}
